import CONSTANT from "../constants"

export const TRADE_FLOW_TYPES = [
  { id: CONSTANT.tradingOperation.export, label: 'Экспорт', prepositionalLabel: 'экспорте' },
  { id: CONSTANT.tradingOperation.import, label: 'Импорт', prepositionalLabel: 'импорте' },
];